import jsPDF from "jspdf";
import "jspdf-autotable";
import rwittmer from "../../../icons/logo_rwittmer.png";
import tiptoptravel from "../../../icons/TipTopTravel.jpg";
import singleBed from "../../../icons/single_bed.png";
import doubleBed from "../../../icons/double_bed.png";
import bunk from "../../../icons/bunk.png";
import singleBedDown from "../../../icons/single_bed_down.png";
import singleBedUp from "../../../icons/single_bed_up.png";
import path from "path-browserify";

const berthIcons = {
  "single_bed.png": singleBed,
  "double_bed.png": doubleBed,
  "bunk.png": bunk,
  "single_bed_down.png": singleBedDown,
  "single_bed_up.png": singleBedUp,
};

export function getBerthIcon(iconName) {
  return Object.prototype.hasOwnProperty.call(berthIcons, iconName)
    ? berthIcons[iconName]
    : undefined;
}

export function getCabinBerthIcons(passengers) {
  if (!passengers || passengers.length === 0) {
    return [];
  }

  return (passengers[0].berthIconNames || [])
    .map(function (iconName) {
      return getBerthIcon(iconName);
    })
    .filter(Boolean);
}

export function drawBerthIcon(doc, data) {
  if (data.column.dataKey !== "cabIcon") {
    return;
  }

  var cellBerthIcons = data.row.raw.berthIcons;
  if (!cellBerthIcons || cellBerthIcons.length === 0) {
    return;
  }

  var iconSize = 12;
  var gap = 3;
  var totalWidth =
    cellBerthIcons.length * iconSize + (cellBerthIcons.length - 1) * gap;

  var startX = data.cell.x + (data.cell.width - totalWidth) / 2;
  var iconY = data.cell.y + (data.cell.height - iconSize) / 2;

  cellBerthIcons.forEach(function (berthIcon, index) {
    var berthImage = new Image();
    berthImage.src = path.resolve(berthIcon);
    var iconX = startX + index * (iconSize + gap);
    doc.addImage(berthImage, "PNG", iconX, iconY, iconSize, iconSize);
  });
}

function addFooter(doc) {
  for (let i = 1; i <= doc.internal.getNumberOfPages(); i++) {
    doc.setPage(i);

    doc.line(20, 816, 570, 816);

    doc.setFontSize(10);
    var date = new Date();
    var currentDate =
      date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
    doc.text(20, 830, currentDate);

    doc.setFontSize(10);
    doc.setFont("helvetica", 'bold');
    doc.text(
      500,
      830,
      "Página " + i + " de " + doc.internal.getNumberOfPages()
    );
  }
}

function createSignTable(doc, voucher) {
  var columnsSign = [{ title: "", dataKey: "sign" }];

  var rowsSign = [
    { sign: "" },
    { sign: "" },
    { sign: "" },
    { sign: "" },
    { sign: "" },
    { sign: "____________________________" },
    { sign: `${voucher.user}  - Sales Executive` },
    { sign: `${voucher.user_phone}`},
  ];

  doc.autoTable(columnsSign, rowsSign, {
    didDrawPage: function () {
      return false; // Don't draw header row
    },
    startY: doc.lastAutoTable.finalY + 5,
    columnStyles: {
      sign: {
        fillColor: [255, 255, 255],
        fontStyle: "bold",
        textColor: [0, 0, 0],
      },
    },
    styles: {
      overflow: "linebreak",
      fontSize: 9,
      cellPadding: 1,
    },
  });
}

export default function VoucherPDF(cruise, company, voucher) {

  var reportLogoRolfWittmer = new Image();
  reportLogoRolfWittmer.src = path.resolve(rwittmer);
  var reportLogoTipTipTravel = new Image();
  reportLogoTipTipTravel.src = path.resolve(tiptoptravel);
  var doc = new jsPDF("p", "pt");

  // HEADER

  // IMAGE (LOGO)

  doc.addImage(reportLogoRolfWittmer, "PNG", 425, 10, 135, 50);

  doc.setFontSize(18);
  doc.setFont("helvetica", "bold");
  doc.text("VOUCHER.", 40, 34);
  doc.setFontSize(16);

  doc.text(cruise.yacht_code, 40, 55);

  if (company.code === "rw") {
    doc.setFontSize(8);
    doc.text("RWTG-REG-51", 40, 70);
  }

  var columnsHeader = [
    { title: "", dataKey: "label" },
    { title: "", dataKey: "name" },
  ];

  var itinerary = voucher.itinerary;
  var startDate = voucher.start_date_format;
  var endDate = voucher.end_date_format;

  var rowsHeader = [
    { label: "Cruise Date", name: startDate + " - " + endDate },
    { label: "Itinerary", name: itinerary },
    { label: "For", name: voucher.passenger_direct ? voucher.passenger_direct + ' / ' + voucher.agency_name : voucher.agency_name },
  ];

  doc.autoTable(columnsHeader, rowsHeader, {
    didDrawPage: function () {
      return false; // Don't draw header row
    },
    startY: 80,
    styles: {
      lineColor: [0, 0, 0],
      lineWidth: 0.0,
      fontSize: 12,
      overflow: 'ellipsize', // <- Esto hace que el texto corte con ...
    },
    columnStyles: {
      label: { cellWidth: 90, textColor: [0, 0, 0] },
      name: { textColor: [0, 0, 0] },
    },
  });

  doc.line(
    25,
    doc.lastAutoTable.finalY + 10,
    570,
    doc.lastAutoTable.finalY + 10
  );
  doc.line(
    25,
    doc.lastAutoTable.finalY + 11,
    570,
    doc.lastAutoTable.finalY + 11
  );

  // included

  var columnsIncluded = [{ title: "Included services", dataKey: "included" }];
  var rowsIncluded = [{ included: voucher.included }];
  doc.autoTable(columnsIncluded, rowsIncluded, {
    startY: doc.lastAutoTable.finalY + 30,
    styles: {
      overflow: "linebreak",
      lineColor: [0, 0, 0],
      lineWidth: 0.1,
      fontSize: 9,
    },
    columnStyles: {
      included: { fillColor: [255, 255, 255] },
    },
    headStyles: {
      fillColor: [248, 248, 248],
      textColor: [0, 0, 0],
    },
  });

  // not included

  var columnsNotIncluded = [{ title: "Not Included services", dataKey: "notIncluded" }];

  var rowsNotIncluded = [{ notIncluded: voucher.notIncluded }];

  doc.autoTable(columnsNotIncluded, rowsNotIncluded, {
    startY: doc.lastAutoTable.finalY + 10,
    styles: {
      overflow: "linebreak",
      lineColor: [0, 0, 0],
      lineWidth: 0.1,
      fontSize: 9,
    },
    columnStyles: {
      notIncluded: { fillColor: [255, 255, 255] },
    },
    headStyles: {
      fillColor: [248, 248, 248],
      textColor: [0, 0, 0],
    },
  });

  // wetsuits

  if (voucher.wetsuitsRental) {
    var columnsWetsuits = [{ title: "Wetsuits rental", dataKey: "wetsuits" }];

    var rowsWetsuits = [{ wetsuits: voucher.wetsuitsRental }];

    doc.autoTable(columnsWetsuits, rowsWetsuits, {
      startY: doc.lastAutoTable.finalY + 10,
      styles: {
        overflow: "linebreak",
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
        fontSize: 9,
      },
      columnStyles: {
        wetsuits: { fillColor: [255, 255, 255] },
      },
      headStyles: {
        fillColor: [248, 248, 248],
        textColor: [0, 0, 0],
      },
    });
  }

  // remarks

  var columnsRemarks = [{ title: "Remarks", dataKey: "remarks" }];

  var rowsNotRemarks = [{ remarks: voucher.remarks }];

  doc.autoTable(columnsRemarks, rowsNotRemarks, {
    startY: doc.lastAutoTable.finalY + 10,
    styles: {
      overflow: "linebreak",
      lineColor: [0, 0, 0],
      lineWidth: 0.1,
      fontSize: 9,
    },
    columnStyles: {
      remarks: { fillColor: [255, 255, 255] },
    },
    headStyles: {
      fillColor: [248, 248, 248],
      textColor: [0, 0, 0],
    },
  });

  // BODY

  var columnsHeaderPassenger = [{ title: "PASSENGERS", dataKey: "itinerary" }];

  var rowsHeaderPassenger = [];
  doc.autoTable(columnsHeaderPassenger, rowsHeaderPassenger, {
    didDrawPage: function () {
      return false; // Don't draw header row
    },
    overflow: "linebreak",
    startY: doc.lastAutoTable.finalY + 10,
    styles: {
      lineColor: [0, 0, 0],
      lineWidth: 0.1,
      fontSize: 9,
    },
    columnStyles: {
      itinerary: { fillColor: [255, 255, 255] },
    },
    headStyles: {
      fillColor: [28, 133, 199],
      textColor: [255, 255, 255],
    },
  });

  var columnPassenger = [
    { title: "CAB", dataKey: "cab" },
    { title: "", dataKey: "cabIcon" },
    { title: "Name", dataKey: "nombre" },
    { title: "Deck", dataKey: "deck" },
  ];

  var rowsPassenger = [];
  var cabinMap = {}; // Group passengers by cabin

  // Group passengers by cabin
  voucher.passengers.forEach(function (passenger) {
    var cabin = passenger.cabin_name;
    if (!cabinMap[cabin]) {
      cabinMap[cabin] = [];
    }
    cabinMap[cabin].push({
      name: passenger.last_name + " / " + passenger.first_name,
      deck: passenger.deck_name,
      berthIconNames: passenger.berth_icons
        ? passenger.berth_icons.split(",")
        : [],
    });
  });

  // Create rows combining passengers from same cabin
  Object.keys(cabinMap)
    .sort(function (a, b) {
      return parseInt(a) - parseInt(b);
    })
    .forEach(function (cabin) {
      var passengers = cabinMap[cabin];
      var nombres = passengers.map(function (p) {
        return `- ${p.name}`;
      }).join("\n");

      // Get deck only once (same for all passengers in same cabin)
      var deck = passengers.length > 0 ? passengers[0].deck : "";

      rowsPassenger.push({
        cab: cabin,
        nombre: nombres,
        deck: deck,
        berthIcons: getCabinBerthIcons(passengers),
      });
    });

  doc.autoTable(columnPassenger, rowsPassenger, {
    startY: doc.lastAutoTable.finalY,
    head: [
      [
        { content: "CAB", colSpan: 2, styles: { halign: "center", valign: "middle" } },
        { content: "Name" },
        { content: "Deck" },
      ],
    ],
    styles: {
      lineColor: [0, 0, 0],
      lineWidth: 0.1,
      overflow: "linebreak",
      fontSize: 10,
      fillColor: [255, 255, 255],
    },
    headStyles: {
      fillColor: [248, 248, 248],
      textColor: [0, 0, 0],
    },
    alternateRowStyles: {
      fillColor: [255, 255, 255],
    },
    columnStyles: {
      cab: {
        cellWidth: 38,
        fillColor: [28, 133, 199],
        textColor: [255, 255, 255],
        halign: "center",
        valign: "middle",
        fontSize: 16,
        fontStyle: "bold",
        cellPadding: { top: 8, bottom: 8, left: 4, right: 4 },
        minCellHeight: 34,
      },
      cabIcon: {
        cellWidth: 40,
        fillColor: [255, 255, 255],
        halign: "center",
        valign: "middle",
        cellPadding: { top: 8, bottom: 8, left: 2, right: 2 },
        minCellHeight: 34,
      },
      deck: {
        halign: "center",
        valign: "middle",
      },
    },
    didDrawCell: function (data) {
      drawBerthIcon(doc, data);
    },
  });

  createSignTable(doc, voucher);

  // GENERATE PDF
  addFooter(doc);
  doc.save("Voucher" + cruise.code + ".pdf");
}
